import React from 'react';
import { Box, Container } from '@mui/material';
import { BRAND } from '../../constants/branding';
import { glowOrbSx } from '../../constants/brandStyles';

interface AuthPageShellProps {
  children: React.ReactNode;
}

/** Dark branded wrapper for login / register / verify pages */
export const AuthPageShell: React.FC<AuthPageShellProps> = ({ children }) => (
  <Box
    sx={{
      minHeight: '100vh',
      bgcolor: BRAND.colors.bg,
      color: BRAND.colors.text,
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      py: 4,
    }}
  >
    <Box sx={glowOrbSx(360, '10%', '70%', 0.14)} />
    <Box sx={glowOrbSx(280, '60%', '-10%', 0.1)} />
    <Container component="main" maxWidth="sm" sx={{ position: 'relative' }}>
      {children}
    </Container>
  </Box>
);

export default AuthPageShell;
